"use strict";

window.slate = window.slate || {};
window.theme = window.theme || {};
$.pp = $.pp || {};

/****************************************************************
 * Js imports
 ****************************************************************/
/****************************************************************
 * CODE ajaxCart
 ****************************************************************/

!function ($, document, window, undefined) {
  /**
   * Plugin name
   */
  var _pluginName = 'ajaxCart';

  /**
   * @param jQuery Element Wrapping container div
   * @return ajaxCart_plugin
   */
  var ajaxCart_plugin = function ajaxCart_plugin($element, options) {
    // Scope it
    var self = this;
    self.$body = $('body');
    self.$element = self.$body.find('[data-ajax-cart]');
    self.xhrCount = 0;
    window.global_cart_drawer = true;

    // Set default options
    var defaults = {
      cart_image_size: "100x100_crop_center",
      notification_image_size: "100x",
      onAddShowNotification: true,
      onAddShowCart: true,
      renderCart: true
    };
    var metaOptions = self.$element.data('ajax-cart');
    self.options = $.extend({}, defaults, metaOptions);
    if ($.pp.debug) {
      console.log('Init ajaxCart:', self.$element, self.options);
    }

    // Find containers
    self.$cartForm = self.$element.find('[data-ajax-cart-form]');
    self.$ajaxCartWrapper = self.$element.find('[data-ajax-cart-wrapper]');
    self.$ajaxCartContainer__products = self.$ajaxCartWrapper.find('[data-ajax-cart-container="products"]');
    self.$cartContainer__products = $('[data-cart-container="products"]');
    self.$cartIconLink = $('[data-ajax-cart-link]');
    self.$cartIconWrapper = $('[data-ajax-cart-icon-wrapper]');
    self.$cartIconQuantity = self.$cartIconWrapper.find('[data-ajax-cart-icon-quantity]');

    // Get the cart
    self.getCart(false);

    // Handle click events
    self.handleEvents();
  };

  /**
   * Handle events
   *
   * @return void
   * @access public
   */
  ajaxCart_plugin.prototype.handleEvents = function () {
    var self = this;

    // catch click on cart drawer icon click
    self.$body.on('click', '[data-ajax-cart-link]', function (event) {
      event.preventDefault();
      self.toggleCart(true);
    });

    // Catch click on Add to cart buttons
    self.$body.on('click', '[data-ajax-cart-add-button]', function (event) {
      event.preventDefault();
      // Add product to cart
      self.addToCart($(this));
    });

    // Catch click on quantity modifiers in ajax cart
    self.$ajaxCartContainer__products.on('click', '[data-ajax-cart-quantity-modifier]', function (event) {
      self.handleQuantityUpate(event);
    });

    // Catch click on quantity modifiers on the cart page
    self.$body.on('click', '[data-ajax-cart-quantity-modifier]', function (event) {
      self.handleQuantityUpate(event);
    });

    // Catch change of quantity in ajax cart
    self.$ajaxCartContainer__products.on('change keyup blur', '[data-ajax-cart-quantity-value]', function (event) {
      self.handleQuantityUpate(event);
    });

    // Catch change of quantity on the cart page
    self.$body.on('change keyup blur', '[data-ajax-cart-quantity-value]', function (event) {
      self.handleQuantityUpate(event);
    });

    // Prevent clickthrough on wrapper
    self.$ajaxCartWrapper.on('click', function (event) {
      event.stopPropagation();
    });

    // Catch click on product remove in ajax cart
    $('body').on('click', '[data-ajax-cart-template-element="remove"]', function (event) {
      event.preventDefault();
      var $productRow = $(this).closest('[data-ajax-cart-template-element="row"]').slideUp(300);
      self.removeProduct($productRow);
    });
  };

  /**
   * Remove a product row
   *
   * @return void
   * @access public
   */
  ajaxCart_plugin.prototype.removeProduct = function ($row) {
    var self = this;

    // Set quantity input to 0
    $row.find('[data-ajax-cart-quantity-value]').val(0);

    // Find product id
    var variantInputId = $row.find('[data-ajax-cart-quantity-id]').val();
    var postData = {
      id: variantInputId,
      quantity: 0
    };
    if ($.pp.debug) {
      console.log('Update ajaxCart:', postData);
    }

    // Post the updates
    self.postAjaxCartUpdates(postData);
  };

  /**
   * Show a notification of the added product
   *
   * @return void
   * @access public
   */
  ajaxCart_plugin.prototype.handleQuantityUpate = function (event) {
    event.preventDefault();
    var self = this;
    var $trigger = $(event.currentTarget);
    var $wrapper = $trigger.closest('[data-ajax-cart-quantity-modifiers]');

    // Find quantity input
    var $quantityInput = $wrapper.find('[data-ajax-cart-quantity-value]');
    var $variantInput = $wrapper.find('[data-ajax-cart-quantity-id]');

    // Get order quantity
    var packageQuantity = $wrapper.find('[data-package-quantity]').data('package-quantity');

    // if triggered by +/- button
    if ($trigger.data('ajax-cart-quantity-modifier')) {
      // Update quantity
      var oldQuantity = parseInt($quantityInput.val());
      var newQuantity = Math.max(oldQuantity + parseInt($trigger.data('ajax-cart-quantity-modifier')), 1);

      // If quantity is less than minimum order quantity
      if (newQuantity < packageQuantity) {
        var newQuantity = packageQuantity;
      }

      // Set new value
      $quantityInput.val(newQuantity);
    } else {
      // if triggered by manual input

      var newQuantity = parseInt($quantityInput.val());

      // If quantity is less than minimum order quantity
      if (newQuantity < packageQuantity) {
        var newQuantity = packageQuantity;
      }
      // Else set quantity according to order quantity
      else {
        // Calculate how many times the order quantity fits in the current quantity
        var orderMultiplier = Math.ceil(newQuantity / packageQuantity);

        // Set current quantity by multiplying order quantity times order multiplier
        var newQuantity = packageQuantity * orderMultiplier;
      }
    }
    var postData = {
      id: $variantInput.val(),
      quantity: newQuantity
    };
    if ($.pp.debug) {
      console.log('Update ajaxCart:', postData);
    }

    // Post the form
    self.postAjaxCartUpdates(postData);
  };

  /**
   * Update Cart Icon Quantity
   *
   * @return void
   * @access public
   */
  ajaxCart_plugin.prototype.updateCartIconQuantity = function (newQuantity) {
    var self = this;

    // Update counter badge text and data attribute
    $('.cart-link__bubble').text(newQuantity);
    setTimeout(function () {
      $('body').removeClass('ajax-cart-wrapper--loading');
    }, 1000);
  };

  /**
   * Add product to cart
   *
   * @return void
   * @access public
   */
  ajaxCart_plugin.prototype.addToCart = function ($el) {
    var self = this;

    // Find the form
    var $form = $el.closest('form');
    var orderedQuantity = $form.find('[data-ajax-cart-quantity]').val();
    if (isNaN(parseFloat(orderedQuantity))) {
      return;
    }
    var addData = $form.serialize();
    if ($.pp.debug) {
      console.log('Add to Cart:', addData, orderedQuantity);
    }
    self.handleAddToCart(addData);
  };

  /**
   * Handle add to cart Ajax
   *
   * @return void
   * @access public
   */
  ajaxCart_plugin.prototype.handleAddToCart = function (addData, helper) {
    var self = this;

    // Sequence number for the current invocation of function
    var seqNumber = ++self.xhrCount;
    $.ajax({
      url: '/cart/add.js',
      type: 'POST',
      data: addData,
      dataType: 'json',
      beforeSend: function beforeSend() {
        if ($.pp.debug) {
          console.log('Send to Cart: ' + seqNumber, addData);
        }
      },
      error: function error(XMLHttpRequest) {
        console.log('Add to Cart error:', XMLHttpRequest);
      }
    }).done(function (data) {
      if (seqNumber === self.xhrCount) {
        // Get the cart
        self.getCart(helper);
      }
    }).always(function (data) {});
  };

  /**
   * Post cart updates;
   *
   * @return void
   * @access public
   */
  ajaxCart_plugin.prototype.postAjaxCartUpdates = function (data) {
    var self = this;

    // Sequence number for the current invocation of function
    var seqNumber = ++self.xhrCount;
    $.ajax({
      type: "POST",
      url: '/cart/change.js',
      data: data,
      dataType: 'json',
      success: function success(cart) {
        if ($.pp.debug) {
          console.log('Cart update ' + seqNumber + ' success:', cart);
        }

        // If this is the last ajax Call
        if (seqNumber === self.xhrCount) {
          self.updateCart(cart);
        }
      },
      error: function error(cart) {
        // If ( $.pp.debug ) { console.log( 'Add to Cart always:', data ); }
        if (seqNumber === self.xhrCount) {
          // Get the cart
          self.getCart(self.options.onAddShowCart);
        }
      }
    });
  };

  /**
   * Update the cart
   *
   * @return void
   * @access public
   */
  ajaxCart_plugin.prototype.updateCart = function (cart, showCart) {
    var self = this;

    // If we're on the cart page, with the cart-form still visible but no products in it (user removed the last product)
    if (window.location.href.indexOf('/cart') > -1 && $('#cartform').length && cart.item_count == 0) {
      // Reload the page to show the ampty cart message
      window.location.reload(true);
      return;
    }
    self.updateCartSection(showCart);
    self.updateCartIconQuantity(cart.item_count);
  };

  /**
   * Render the cart
   *
   * @return void
   * @access public
   */
  ajaxCart_plugin.prototype.getCart = function (openTheCart) {
    var self = this;
    Shopify.getCart(function (cart) {
      if ($.pp.debug) {
        console.log('ajaxCart:', cart);
      }
      self.updateCart(cart, openTheCart);
    });
  };

  /**
   * Update the cart section
   *
   * @return void
   * @access public
   */
  ajaxCart_plugin.prototype.updateCartSection = function (showCart) {
    var self = this;
    $('body').addClass('ajax-cart-wrapper--loading');

    // update section
    $.ajax({
      url: 'https://www.primeprometics.com?section_id=cart-drawer',
      type: 'GET',
      error: function error(XMLHttpRequest) {
        console.log('Get cart section error:', XMLHttpRequest);
      }
    }).done(function (data) {
      $('#shopify-section-cart-drawer').replaceWith(data);
      var discount = $('#shopify-section-cart-drawer').find('[data-discount]').data('discount');
      $('#shopify-section-cart-drawer').find($('[data-select-variant]')).on('click', function () {
        $(this).closest('.product-relation__variants').addClass('is-open');
        setTimeout(function () {
          $('body').one('click', function () {
            $('.product-relation__variants.is-open').removeClass('is-open');
          });
        }, 250);
      });
      $('#shopify-section-cart-drawer').find($('[data-variant-id]')).on('click', function () {
        $(this).addClass('selected');
        var image = $(this).find('[data-variant-image]');
        var image = image.clone();
        $(this).closest('.product-relation__variants').find('[data-add-to-cart] [data-add-image]').html(image);
        $(this).closest('.product-relation__variants').removeClass('is-open').addClass('is-selected');
      });

      // catch relations add to cart
      $('#shopify-section-cart-drawer').find($('[data-add-to-cart]')).on('click', function () {
        $(this).closest('.product-relation__variants').addClass('product-relation__variants--loader');
        var id = $(this).closest('.product-relation__variants').find('li.selected').data('variant-id');
        var data = {};
        if (discount > 0) {
          data = {
            id: id,
            quantity: 1,
            properties: {
              _added_from: 'cart-drawer',
              _cart_drawer_discount: discount
            }
          };
        } else {
          data = {
            id: id,
            quantity: 1,
            properties: {
              _added_from: 'cart-drawer'
            }
          };
        }
        dataLayer.push({
          'event': 'add_to_cart_from_drawer'
        });
        self.handleAddToCart(data);
      });

      // catch variant color
      $('#shopify-section-cart-drawer').find($('[data-add-image]')).on('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        $(this).closest('.product-relation__variants').removeClass('is-selected').addClass('is-open');
        setTimeout(function () {
          $('body').one('click', function () {
            $('.product-relation__variants.is-open').removeClass('is-open');
          });
        }, 250);
      });
      var one = true;
      $('[data-pdp-atc]').one('click', function (event) {
        event.preventDefault();
        var element = $(this);
        if (one) {
          var _one = false;
          var id = element.closest('.product-single__form').find('[data-productid] option:selected').val();
          var quantity = element.closest('.sticky-cart-qty').find('.double-qty option:selected').val();
          var data = {
            id: id,
            quantity: quantity
          };
          self.handleAddToCart(data, true);
          _one = true;
        }
      });
      if (showCart) {
        self.$body.toggleClass('ajax-cart__is-open');
      }
    });
  };

  /**
   * Open the cart
   *
   * @return void
   * @access public
   */
  ajaxCart_plugin.prototype.toggleCart = function (skipUpdate) {
    var self = this;

    // update section
    if (skipUpdate) {
      self.$body.toggleClass('ajax-cart__is-open');
    } else {
      this.updateCartSection(true);
    }
    if (self.$body.hasClass('ajax-cart__is-open')) {
      dataLayer.push({
        'event': 'cart_drawer_view'
      });
    }
  };

  /**
   * ajaxCart plugin
   *
   * @return jQuery objects
   */
  $.fn.ajaxCart = function (options) {
    // Put args in array
    var args = Array.prototype.slice.call(arguments, 1);

    // Initialize the items
    return this.each(function () {
      // Store the element the plugin is set on
      var $element = $(this);

      // Guard if plugin was already initted
      var instance = $element.data('plugin_' + _pluginName);

      // If plugin was not innited
      if (!instance) {
        // Init plugin on element and set guard data on element
        $element.data('plugin_' + _pluginName, new ajaxCart_plugin($element, options));
      } else {
        // If instance already created call method from plugin
        if (typeof options === 'string') {
          instance[options].apply(instance, args);
        }
      }
    });
  };
}(jQuery, document, window);

/****************************************************************
 * CODE init
 ****************************************************************/

$.pp.init = function () {
  // Set debugging flag
  $.pp.debug = false;

  // Set global variables
  $.pp.setVars();

  // Handle window resizing
  $.pp.windowResizeHandler();

  // Init ajax cart
  $('body').ajaxCart();

  // Landing page add to cart
  $('[data-landing-add-to-cart]').on('click', function (event) {
    event.preventDefault();
    $('[data-pdp-atc]').trigger('click');
  });
  $('.pink-btn[href="#"]').on('click', function (event) {
    event.preventDefault();
    $('[data-pdp-atc]').trigger('click');
  });
  $('.pink-button[href="#"]').on('click', function (event) {
    event.preventDefault();
    $('[data-pdp-atc]').trigger('click');
  });
};

/**
 * Functions to be called after window resizing is finished
 */
$.pp.onWindowResize = function () {
  var self = this;

  // Get new global window width
  $.pp.ww = $(window).width();
};

/**
 * Handle window resizing
 */
$.pp.windowResizeHandler = function () {
  // Call window resize functions 200ms after window stops being resized
  var timeoutOffset = false;
  $(window).resize(function () {
    if (timeoutOffset !== false) {
      clearTimeout(timeoutOffset);
    }
    timeoutOffset = setTimeout(function () {
      $.pp.onWindowResize();
    }, 200);
  });
};

/**
 * Set global variables
 */
$.pp.setVars = function () {
  var self = this;
  if (window.location.host.indexOf('localhost') > -1 || window.location.host.indexOf('myshopify') > -1) {
    $.pp.debug = true;
  }
  if ($.pp.debug) {
    console.log('Init CODE js with debugging');
  }

  // Get window width
  $.pp.onWindowResize();

  // Check for localstorage
  $.pp.localStorage = $.pp.localStorageTest();

  // Set if page is in theme editor
  if (Shopify.designMode) {
    $.pp.themeEditor = true;
    $('body').addClass('theme-editor');
    if ($.pp.debug) {
      console.log('Theme editor active');
    }
  }
};

/**
 * Test for localStorage
 */
$.pp.localStorageTest = function () {
  var test = 'test';
  try {
    localStorage.setItem(test, test);
    localStorage.removeItem(test);
    return true;
  } catch (e) {
    return false;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {
  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function findInstance(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },
  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function removeInstance(array, key, value) {
    var i = array.length;
    while (i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }
    return array;
  },
  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function compact(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];
    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },
  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function defaultTo(value, defaultValue) {
    return value == null || value !== value ? defaultValue : value;
  }
};

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = function () {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;
    var moneyCentsDelimiter = theme.moneyCentsDelimiter;
    var moneyThousandsDelimiter = theme.moneyThousandsDelimiter;
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, moneyThousandsDelimiter);
      decimal = slate.utils.defaultTo(decimal, moneyCentsDelimiter);
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? decimal + parts[1] : '';
      return dollarsAmount + centsAmount;
    }
    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', moneyCentsDelimiter);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, moneyThousandsDelimiter, moneyCentsDelimiter);
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, moneyThousandsDelimiter, moneyCentsDelimiter);
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }
    return formatString.replace(placeholderRegex, value);
  }
  return {
    formatMoney: formatMoney
  };
}();

/**
 * Initialize CODE JS
 */
$.pp.init();

/**
 * shopify Theme editor Events
 */
if ($.pp.themeEditor) {
  $(document).on('shopify:section:load', function (e) {
    var $parentSection = $('#shopify-section-' + e.detail.sectionId);
    var blockId = e.detail.blockId;

    // Re-init featured product
    if ($parentSection.hasClass('product-featured-section')) {
      $('[data-section-type="product"]', $parentSection).product();
    }
    // Re-init swiper
    if ($parentSection.hasClass('swiper-section')) {
      $('[data-swiper]', $parentSection).swiperLoader();
    }
  }).on('shopify:section:reorder', function (e) {}).on('shopify:section:unload', function (e) {
    var $parentSection = $('#shopify-section-' + e.detail.sectionId);
    var blockId = e.detail.blockId;
  }).on('shopify:block:select', function (e) {
    var $parentSection = $('#shopify-section-' + e.detail.sectionId);
    var blockId = e.detail.blockId;

    // Edit swiper slide
    if ($parentSection.hasClass('swiper-section')) {
      var $slide = $(e.target);
      $('[data-swiper]', $parentSection).swiperLoader('editSlide', $slide);
    }
  }).on('shopify:block:deselect', function (e) {
    var $parentSection = $('#shopify-section-' + e.detail.sectionId);
    var blockId = e.detail.blockId;
  });
}